import dayjs from "dayjs";

export type FieldColumn = {
  key: string;
  value: string;
  locked?: boolean;
  minWidth?: number;
  align?: "left" | "center" | "right";
};

export const FD_DUE_DATE_REPORT = "Due date in next 30 days";

/** aumsampaan UI segment id for Corporate FD tables */
export const FD_TABLE_SEGMENT = "Corporate FD";

export const FD_REPORT_TYPE_OPTIONS = [
  { value: "Holding", label: "Unrealized" },
  { value: FD_DUE_DATE_REPORT, label: FD_DUE_DATE_REPORT },
] as const;

export const FD_QUICK_REPORTS = [
  { id: "holding", label: "Unrealized", reportType: "Holding" },
  { id: "due-date", label: FD_DUE_DATE_REPORT, reportType: FD_DUE_DATE_REPORT },
];

export const INVESTOR_COLUMN: FieldColumn = {
  key: "investorDisplay",
  value: "Investor Name",
  locked: true,
  minWidth: 200,
};

/** aumsampaan Corporate FD Unrealized table (HOLDING_TXN + Gain Type / Adj. Cost / CAGR / Days / STT). */
export const FD_UNREALIZED_HOLDING_COLUMNS: FieldColumn[] = [
  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },
  { key: "type", value: "Gain Type", locked: true, minWidth: 132 },
  { key: "folioNumber", value: "FD receipt", minWidth: 120 },
  { key: "transactionDate", value: "Transaction Date", minWidth: 112 },
  { key: "maturityDate", value: "Maturity Date", minWidth: 112 },
  { key: "tenure", value: "Tenure", minWidth: 88 },
  { key: "investedAmount", value: "Invested Amt.", minWidth: 128 },
  { key: "currentAmount", value: "Current Value", minWidth: 128 },
  { key: "adjustedCostPrice", value: "Adj. Cost", minWidth: 112 },
  { key: "roi", value: "Intrest Rate", minWidth: 112 },
  { key: "cagr", value: "CAGR", minWidth: 96 },
  { key: "gainLoss", value: "P&L", minWidth: 132 },
  { key: "gainLossPercentage", value: "P&L %", minWidth: 96 },
  { key: "nifty50GainLossPercentage", value: "Nifty 50 G/L\n(%)", minWidth: 84 },
  { key: "bseSensexGainLossPercentage", value: "BSE Sensex\n(%)", minWidth: 84 },
  { key: "nifty500GainLossPercentage", value: "Nifty 500 G/L\n(%)", minWidth: 92 },
  { key: "niftyMidCap100GainLossPercentage", value: "Nifty Midcap G/L\n(%)", minWidth: 100 },
  { key: "niftyNext50GainLossPercentage", value: "Nifty Next 50 G/L\n(%)", minWidth: 100 },
  { key: "niftyBankGainLossPercentage", value: "Nifty Bank G/L\n(%)", minWidth: 92 },
  { key: "days", value: "Avg. Days", minWidth: 88 },
  { key: "stt", value: "STT", minWidth: 88 },
  { key: "stampDuty", value: "Stamp Duty", minWidth: 100 },
  { key: "otherExpenses", value: "Other Expenses", minWidth: 112 },
  { key: "brokerage", value: "Brokerage", minWidth: 96 },
];

export const getColumnsForFdReportType = (reportType: string): FieldColumn[] => {
  switch (reportType) {
    case "Holding":
    case FD_DUE_DATE_REPORT:
      return FD_UNREALIZED_HOLDING_COLUMNS;
    default:
      return FD_UNREALIZED_HOLDING_COLUMNS;
  }
};

export const isFdDueDateReport = (reportType: string): boolean =>
  reportType === FD_DUE_DATE_REPORT;

export const reportTypeNeedsDateRange = (reportType: string): boolean =>
  reportType === "Holding";

export const buildDueReportDateRange = (): { startDate: number; endDate: number } => ({
  startDate: dayjs().startOf("day").valueOf(),
  endDate: dayjs().add(1, "month").endOf("day").valueOf(),
});
